import React from 'react';

import { Box } from '@mui/material';

export const Asterisk: React.FunctionComponent = () => (
  <Box
    component='span'
    sx={{
      fontSize: '1.5em',
      color: 'error.main',
      mr: 1,
    }}
  >
    *
  </Box>
);
